import dayjs, { Dayjs } from "dayjs";
import { useState, useEffect } from "react";
import {
  useEvents,
  useYearEvents,
} from "../data-access/calendar-data.provider";
import { useLocation } from "react-router-dom";
import { YearEvent } from "../types/year-event-type";

export const useDateYearEvents = () => {
  const date = new URLSearchParams(useLocation().search).get("date");
  const yearEvents = useYearEvents();

  const [dateYearEvents, setDateYearEvents] = useState<YearEvent[]>([]);

  useEffect(() => {
    const selectedDate = date ? dayjs(JSON.parse(date)) : dayjs();

    const filteredYearEvents: YearEvent[] = yearEvents.filter((yearEvent) => {
      return isAnniversary(selectedDate, yearEvent.date);
    });

    setDateYearEvents(filteredYearEvents);
  }, [date, yearEvents]);

  return dateYearEvents;
};

const isAnniversary = (selectedDate: Dayjs, date: string): boolean => {
  const yearDifference = selectedDate.year() - dayjs(date).year();

  return yearDifference % 5 === 0;
};
